module.exports = __webpack_public_path__ + "assets/5b5da82ae178ecac6a91f8a33d4f8c90.png";